import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { observer, inject } from "mobx-react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import FieldSet from "./FieldSet";

const useStyles = makeStyles(() => ({
  circularProgress: {
    alignSelf: "center",
    margin: 5
  },
  dNone: {
    display: "none"
  }
}));

const Form = inject("store")(
  observer(
    ({
      form,
      form: { onSubmit, name: formName },
      store,
      store: {
        ui: { formSubmitting, initialDisabled }
      },
      fields,
      buttonProps,
      inputProps
    }) => {
      const styles = useStyles();

      return (
        <Fragment>
          <form
            method="POST"
            name={formName}
            noValidate="novalidate"
            onSubmit={onSubmit}
            target={`dummy${formName}`}
          >
            {fields && (
              <FieldSet fields={fields} form={form} inputProps={inputProps} />
            )}
            {fields &&
              fields
                .filter(input => input.type === "button")
                .map(input => {
                  const { title, name: inputName } = input;
                  return (
                    <Button
                      key={formName + inputName}
                      disabled={formSubmitting || initialDisabled}
                      onClick={onSubmit}
                      type="submit"
                      {...buttonProps}
                    >
                      {!formSubmitting ? (
                        title
                      ) : (
                        <CircularProgress
                          className={styles.circularProgress}
                          size={16}
                        />
                      )}
                    </Button>
                  );
                })}
          </form>
          <iframe
            border="0"
            height="0"
            id={`dummy${formName}`}
            name={`dummy${formName}`}
            className={styles.dNone}
            title={`dummy target for ${formName}`}
            width="0"
          />
        </Fragment>
      );
    }
  )
);

export default Form;
